export function groupByKey<T>(items: T[], key: keyof T): Map<string, T[]> {
    return items.reduce((grouped, item) => {
        const groupKey = String(item[key]);
        const group = grouped.get(groupKey);

        if (!group) {
            grouped.set(groupKey, [item]);
        } else {
            group.push(item);
        }

        return grouped;
    }, new Map<string, T[]>());
}
